(function () {
    'use strict';

    angular.module('swif.openbase')
        .controller('SiteBanEditModalCtrl', SiteBanEditModalCtrl)
        .controller('SiteBanValidateModalCtrl', SiteBanValidateModalCtrl);

    function SiteBanEditModalCtrl($scope) {
        console.log('init SiteBanEditModalCtrl');
    }

    function SiteBanValidateModalCtrl($scope) {
        console.log('init SiteBanValidateModalCtrl');

        // Split site thanks to slashes
        var originalSite = $scope.model.site_id[1].split(' /');

        // Format site before render
        $scope.formatedSite = '';
        for (var i=0 ; i <= originalSite.length-1 ; i++) {
        	if (i == originalSite.length-1) {
                $scope.formatedSite += ',';
            }
        	$scope.formatedSite += originalSite[i];
        }
    }

})();
